import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import MainDashboard from "../pages/MainDashboard";
import UserDashboard from "../pages/UserDashboard";
import AdminPage from "../pages/AdminPage";
import AdminRoleLayersPage from "../pages/AdminRoleLayersPage";
import AdminRoleComputePage from "../pages/AdminRoleComputePage";
import AdminUsagePage from "../pages/AdminUsagePage";
import AdminVegetationPage from "../pages/AdminVegetationPage";
import AdminForecastPage from "../pages/AdminForecastPage";
import AdminPestPage from "../pages/AdminPestPage";
import AdminWhatsNewPage from "../pages/AdminWhatsNewPage";
import AcceptInvitePage from "../pages/AcceptInvitePage";
import WorkspaceInvitePage from "../pages/WorkspaceInvitePage";
import CarbonProjectsPage from "../features/carbon-projects/CarbonProjectsPage";
import PublicSflmaPage from "../features/carbon-projects/PublicSflmaPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <MainDashboard />,
  },
  {
    path: "/carbon-projects",
    element: <CarbonProjectsPage />,
  },
  {
    path: "/sflma",
    element: <PublicSflmaPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/admin/role-layers",
    element: <AdminRoleLayersPage />,
  },
  {
    path: "/admin/role-compute-presets",
    element: <AdminRoleComputePage />,
  },
  {
    path: "/admin/usage",
    element: <AdminUsagePage />,
  },
  {
    path: "/admin/vegetation",
    element: <AdminVegetationPage />,
  },
  {
    path: "/admin/forecast",
    element: <AdminForecastPage />,
  },
  {
    path: "/admin/pest",
    element: <AdminPestPage />,
  },
  {
    path: "/admin/whats-new",
    element: <AdminWhatsNewPage />,
  },
  {
    path: "/accept-invite",
    element: <AcceptInvitePage />,
  },
  {
    path: "/workspace-invite",
    element: <WorkspaceInvitePage />,
  },
  {
    path: "/userdashboard",
    element: <UserDashboard />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
